import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { transition1 } from '../transitions';
import { IoIosMail } from "react-icons/io";

const Contact = () => {
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")
  const [role, setRole] = useState("artist")

  return (
    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='section overflow-auto p-14 lg:p-40 mb-44 lg:mb-0'
    >
      <div className='lg:flex flex-2 mt-12 lg:mt-0'>
      <p className='h3 lg:mb-10 lg:hidden flex pt-4'>Let's Connect </p><br />

        {/* Form section — appears first on mobile, second on large screens */}
        <div className='flex-1 flex-col order-1 lg:order-2'>
         
          <form className='flex flex-col lg:pt-0 pt-o space-y-6'>
            <div>
              <p className='mb-2'>You are</p>
              <select
                className='w-full p-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:outline-none bg-white'
                value={role}
                onChange={(e) => setRole(e.target.value)}
              >
                <option value=""></option>
                <option value="artist">Organization / Institution</option>
                <option value="volunteer">Artist / Collective</option>
                <option value="intern">Researcher / Curator</option>
                <option value="collaborator">Volunteer / Activist</option>
                <option value="collaborator">Supporter / Ally</option>
              </select>
            </div>
            <div className='flex lg:flex-row flex-col justify-between'>
              <div className='mb-5 lg:mb-0'>

              <p className='mb-2'>Name</p>
              <input
                className='w-full p-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:outline-none'
                onChange={(e) => setName(e.target.value)}
                value={name}
                placeholder='Your Name'
                type="text"
              />
            </div>
            <div>
              <p className='mb-2 '>Email</p>
              <input
                className='w-full p-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:outline-none'
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                placeholder='Your Email'
                type="email"
              />
            </div>
            </div>
            
            <div>
              <p className='mb-2'>Message</p>
              <textarea
                className='w-full p-2 border border-gray-300 rounded-md outline-none focus:ring-0 focus:outline-none'
                onChange={(e) => setMessage(e.target.value)}
                value={message}
                placeholder='Your Message'
                rows={5}
              />
            </div>
            <button
              type="submit"
              className='mt-4 bg-black text-white py-2 px-4 rounded hover:bg-gray-800 transition'
            >
              Send Message
            </button>
          </form>
        </div>

        {/* Info section — appears second on mobile, first on large screens */}
        <div className='flex-1 order-2 lg:order-1 mt-10 lg:mt-0'>
          <div className='flex flex-col lg:pr-20'>
             <p className='h3 lg:mb-10 lg:flex hidden '> Let's Connect </p><br />

            <div className='lg:p-7 p-4 lg:mb-8 border-2 border-zinc-800 rounded-lg text-zinc-700'>
              <p className='text-sm py-3 hover:scale-105'><span className='text-md text-black'>Organization / Institution:</span> to collaborate on long-term projects, knowledge-sharing, and public initiatives</p>
              <p className='text-sm py-3 hover:scale-105'><span className='text-md text-black'>Artist / Collective:</span> to share your practice and contribute to global creative resistance</p>
              <p className='text-sm py-3 hover:scale-105'><span className='text-md text-black'>Researcher / Curator:</span> to produce critical knowledge, archive struggle, and cultivate radical thought</p>
              <p className='text-sm py-3 hover:scale-105'><span className='text-md text-black'>Volunteer / Activist:</span> to support from the ground up, take part in actions, and build community</p>
              <p className='text-sm py-3 hover:scale-105'><span className='text-md text-black'>Supporter / Ally:</span> to offer resources, amplify our mission, and stand in solidarity</p>
            </div>
            <br />
            {/* <p className='lg:mt-6 text-sm text-justify mt-10'>
              Cartographies of Flux is a living network of resistance, imagination, and action. We invite organizations, institutions, collectives, artists, researchers, activists, and individuals from all backgrounds to stand with us — not as spectators, but as co-creators of a more just, fluid, and interconnected world.
              In the face of ecological collapse, systemic injustice, and cultural erasure, we believe in the power of collaborative gestures — in art, research, and grassroots action — to redraw the lines of possibility. By joining us, you become part of a transdisciplinary movement committed to amplifying voices, dismantling borders, and reimagining the future.
            </p> */}
          </div>
        </div>

      </div>
    </motion.section>
  )
}

export default Contact
